import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import Modal from '@cloudscape-design/components/modal';
import SpaceBetween from '@cloudscape-design/components/space-between';

export interface ConfirmDiscardModalProps {
  visible: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

export function ConfirmDiscardModal({ visible, onKeepEditing, onDiscard }: ConfirmDiscardModalProps) {
  if (!visible) return null;
  return (
    <Modal
      visible
      onDismiss={onKeepEditing}
      header="Discard unsaved changes?"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onKeepEditing}>
              Keep editing
            </Button>
            <Button variant="primary" onClick={onDiscard}>
              Discard changes
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      You have unsaved scope changes. Discard them?
    </Modal>
  );
}
